import { apiMipe } from '@/core/api/';

export const getLastPeibyStudentsie = async (studentSieId, academicYearId) => {
  return await apiMipe.get('/api/pei/getlastpeibystudentsie', {
    params: {
      studentSieId,
      academicYearId,
    },
  });
};

export const getlastsignedpeibystudentsie = async (
  studentSIEId,
  academicYearId
) => {
  return await apiMipe.get('/api/pei/getlastsignedpeibystudentsie', {
    params: {
      studentSIEId,
      academicYearId,
    },
  });
};

export const getPeiById = async (peiId) => {
  return await apiMipe.get('/api/pei/getpeibyid', {
    params: { peiId },
  });
};
